export class MRolePojo {

    roleId: number;
    userRole: string;
    roleKey: string;
    access: string;
    userId: number;

}
